import {Request} from 'common/domain/models/request';

function filterByType(items, filtersSet) {
  return items.filter((item) => {
    return filtersSet.has(item.type);
  });
}

function filterByNotifications(items, filtersSet) {
  return items.filter((item) => {
    return (!filtersSet.has(item.type) && item.status === Request.STATUS_REQUESTED.DISCARD);
  });
}

export default () => {
  return function (items, filters) {
    if (filters.length === 0) {
      return items;
    }
    let filtersSet = new Set(filters);
    let filteredItems = filterByType(items, filtersSet);

    if (filtersSet.has(Request.STATUS_REQUESTED.DISCARD)) {
      filteredItems = filteredItems.concat(filterByNotifications(items, filtersSet));
    }

    return filteredItems;
  };
};



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequests.filters.js